import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "img-wrapper" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vector = _resolveComponent("Vector")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-overlay", { mobile: _ctx.isMobile || _ctx.isTablet }]),
      onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
    }, [
      _createElementVNode("div", _mergeProps({
        class: "modal",
        onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
      }, _ctx.$attrs), [
        _createElementVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "background-image"),
          (_ctx.img && !_ctx.$slots['background-image'])
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: require(`@/assets/${_ctx.img}`),
                alt: "BG"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_Vector)
          ]),
          _createElementVNode("h3", null, _toDisplayString(_ctx.name), 1),
          _renderSlot(_ctx.$slots, "default")
        ])
      ], 16)
    ], 2)
  ]))
}